/**
 * The query parameters deep-linking the booking and reservation details modals
 * (PRO-1514). They live here, rather than each beside its own modal, because
 * each modal links to the other and importing across the pair would make the
 * two component modules circular. Both are re-exported from their modal's
 * component file, which is where callers expect to find them.
 */

export const BOOKING_DETAILS_QUERY_PARAM = 'bookingDetailsId';

export const RESERVATION_DETAILS_QUERY_PARAM = 'reservationDetailsId';
